import React from 'react'
import { Link } from 'gatsby'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookSquare } from '@fortawesome/fontawesome-free-brands'

// images
import Logo from '../assets/images/Logo/Biome_Logo.webp'

const Footer = () => {
    const year = new Date().getFullYear()
    return (
        <footer className="bg-primary relative">
            <div className="semicircle top"></div>
            <div className="items-center justify-center flex flex-col">
                <div className="footerSocials flex flex-row pt-20 text-3xl gap-8 items-center justify-center">
                    <a
                        className="text-gray-50 hover:text-accentPrime duration-300 ease-in-out"
                        href="https://www.facebook.com/Biome-TCG-109010958415020"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faFacebookSquare} />
                    </a>
                    {/* <a
                        className="text-gray-50 hover:text-accentPrime duration-300 ease-in-out"
                        href="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FontAwesomeIcon icon={faInstagram} />
                    </a> */}
                </div>
                <div className="footerContent grid grid-cols-4 pt-8 text-gray-50 max-w-7xl place-content-center">
                    <div className="col-span-full sm:col-span-1 pb-4 sm-pb-0">
                        <Link
                            to="/"
                            className="flex flex-col justify-center items-center"
                        >
                            <img
                                src={Logo}
                                alt="Logo BiomeCard"
                                className="w-1/3 md:w-1/2 h-auto "
                            />
                        </Link>
                    </div>

                    <div className="col-span-full sm:col-span-1 flex flex-col justify-center items-center sm:justify-start pt-5 pb-8 sm:pb-5">
                        <h3 className="font-semibold text-lg uppercase border-b-gray-50 border-b-2 mb-4">
                            COMPANY
                        </h3>
                        <Link to="/en/About" className="footer-link">
                            <span className="font-semibold text-md hover:text-accentPrime duration-300 ease-in-out">
                                About Us
                            </span>
                        </Link>
                        {/* <Link to="/en/Contact" className="footer-link">
                            <span className="font-semibold text-md hover:text-accentPrime duration-300 ease-in-out">
                                Contact
                            </span>
                        </Link> */}
                    </div>
                    <div className="col-span-full sm:col-span-1 flex flex-col justify-center items-center sm:justify-start pt-5 pb-8 sm:pb-5">
                        <h3 className="font-semibold text-lg uppercase border-b-gray-50 border-b-2 mb-4">
                            Contact
                        </h3>
                        {/* <a
                            className="font-semibold text-md hover:text-accentPrime duration-300 ease-in-out"
                            href="tel:123456789"
                        >
                            +123456789
                        </a> */}
                        <a
                            className="font-semibold text-md hover:text-accentPrime duration-300 ease-in-out"
                            href="mailTo:info@biometcg.at"
                        >
                            info@biometcg.at
                        </a>
                    </div>
                    <div className="col-span-full sm:col-span-1 flex flex-col justify-center items-center sm:justify-start pt-5 pb-8 sm:pb-5">
                        <h3 className="font-semibold text-lg uppercase border-b-gray-50 border-b-2 mb-4">
                            Legal
                        </h3>
                        <Link to="/en/Imprint" className="footer-link">
                            <span className="font-semibold text-md hover:text-accentPrime duration-300 ease-in-out">
                                Imprint
                            </span>
                        </Link>
                        <Link to="/en/privacy-policy" className="footer-link">
                            <span className="font-semibold text-md hover:text-accentPrime duration-300 ease-in-out">
                                Privacy Policy
                            </span>
                        </Link>
                    </div>
                    <div className="col-span-full flex justify-center items-center py-8 text-center">
                        <p>
                            © 2021-{year} Copyright: BiomeCard &{' '}
                            <a
                                className="hover:text-accentPrime duration-300 ease-in-out"
                                href="https://the-easycode.eu"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                The-EasyCode
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
